//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import axios, { CancelToken } from "axios";

export default {
  components: {},

  data() {
    return {
      pagename: "page02",
      windowHeight: 0,
      windowWidth: 0,
      Showloading: false,
      date: "",
      location: "G1",
      locations: ["G1", "G2", "G3", "G4", "TRM", "VN"],
      department: "ALL",
      datadetail: [],
      datapending: [],
      percent: 0,
      per_color: "#ffffff",
      donut: "0 100",
      currentTable1: 1,
      maxPage1: 1,
      pending_totalrow: 0,
      pending_start: 0,
      pending_end: 0,
      // processDataEmbAll: [],
      // processDataPrintAll: [],
      // processDataEmb: [],
      // processDataPrint: [],
      // filter_vender_print: '',
      // filter_vendor_print_all: [],
      // filter_vender_emb: '',
      // filter_vendor_emb_all: [],

      columnsLeft: [
        {
          name: "SO_NO_DOC",
          label: "S/O No.",
          field: "SO_NO_DOC",
          sortable: true,
          align: "center",
        },
        {
          name: "GM_NO",
          label: "GM08",
          field: "GM_NO",
          sortable: true,
          align: "center",
        },
        {
          name: "PART",
          label: "Part",
          field: "PART",
          sortable: true,
          align: "center",
        },
        {
          name: "QUEUE_NO",
          label: "Queue",
          field: "QUEUE_NO",
          sortable: true,
          align: "center",
          sort: (a, b) => parseInt(a, 10) - parseInt(b, 10),
        },
        {
          name: "LINE",
          label: "Table",
          field: "LINE",
          sortable: true,
          align: "center",
          sort: (a, b) => parseInt(a, 10) - parseInt(b, 10),
        },
      ],

      columnsRight: [
        {
          name: "MOOD",
          label: "",
          field: "MOOD",
          sortable: false,
          align: "center",
        },
        {
          name: "QUEUE_NO",
          label: "Queue",
          field: "QUEUE_NO",
          sortable: true,
          align: "center",
          sort: (a, b) => parseInt(a, 10) - parseInt(b, 10),
        },
        {
          name: "LINE",
          label: "Table",
          field: "LINE",
          sortable: true,
          align: "center",
          sort: (a, b) => parseInt(a, 10) - parseInt(b, 10),
        },
        {
          name: "SO_NO_DOC",
          label: "S/O No.",
          field: "SO_NO_DOC",
          sortable: true,
          align: "center",
        },
        {
          name: "GM_NO",
          label: "GM08",
          field: "GM_NO",
          sortable: true,
          align: "center",
        },
        {
          name: "PART",
          label: "Part",
          field: "PART",
          sortable: true,
          align: "center",
        },
        {
          name: "TARGET_ACTUAL",
          label: "Target",
          field: "TARGET_ACTUAL",
          sortable: true,
          align: "right",
        },
        {
          name: "ACTUAL_TIME",
          label: "Actual",
          field: "ACTUAL_TIME",
          sortable: true,
          align: "right",
        },
        {
          name: "ACTUAL_TARGET",
          label: "% Act./Target",
          field: "ACTUAL_TARGET",
          sortable: true,
          align: "right",
        },
      ],

      pagination1: {
        rowsPerPage: 20,
      },

      pagination2: {
        rowsPerPage: 15,
      },

      pagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      },

      thumbStyle: {
        right: "2px",
        borderRadius: "0px",
        backgroundColor: "#027be3",
        width: "2px",
        opacity: 0.75,
      },

      barStyle: {
        right: "2px",
        borderRadius: "0px",
        backgroundColor: "#027be3",
        width: "2px",
        opacity: 0.2,
      },

      dense: true,
    };
  },
  created() {
    this.CheckLocal();
    this.LoadFirst();
    this.windowHeight = window.innerHeight;
    this.windowWidth = window.innerWidth;
  },
  async mounted() {
    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      this.resize();
    });
  },
  watch: {
    // location: function (newValue, oldValue) {
    //   this.LoadData();
    // },
    // department: function (newValue, oldValue) {
    //   this.LoadData();
    // },
    date: function (newValue, oldValue) {},
  },
  methods: {
    resize() {
      if (this.$q.screen.width >= 1900) {
        this.pagination1.rowsPerPage = 20;
        this.pagination2.rowsPerPage = 25;
        this.dense = true;
      } else {
        this.pagination2.rowsPerPage = 15;
        this.dense = true;
      }
    },
    keeplocation() {
      this.keeploc(this.pagename, this.location);
      this.LoadDataAll();
    },

    LoadFirst() {
      this.getloc();
      this.CurrDate();
      this.pulling = setTimeout(() => {
        this.chkAuthen("", "");

        this.pullData();
        this.resize();
        this.LoadDataAll();
      }, 1000);
    },

    getloc() {
      this.Refresh = false;
      const postjson = {
        authen: { keycode: this.$keycode },
        input: {
          uid: this.$store.getters.uid,
          syscode: this.$syscode,
          pagename: this.pagename,
        },
      };
      axios({
        method: "post",
        url: `${this.$apiflask}/log/getloc`, // php
        data: postjson,
      }).then((res) => {
        if (res.data.loc != null) {
          this.location = res.data.loc;
        }
      });
    },

    pullData() {
      this.pulling = setInterval(() => {
        var currentdate = new Date();
        if (
          currentdate.getMinutes() % 5 == 0 &&
          currentdate.getSeconds() == 0
        ) {
          this.LoadDataDetail();
          this.LoadDataPending();
        }
        // console.log(currentdate)
      }, 1000);
    },

    isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },

    CurrDate() {
      axios({
        method: "post",
        url: `${this.$apiflask}/curdate`,
      }).then((res) => {
        console.log(res.data);
        this.date = res.data.dte;
      });
    },
    async LoadDataAll() {
      this.currentTable1 = 1
      this.Showloading = true;

      const stepDetail = this.LoadDataDetail();
      const stepPending = this.LoadDataPending();

      let a = await stepDetail;
      let b = await stepPending;

      this.Showloading = false;
    },
    LoadDataDetail() {
      let params = new FormData();
      params.append("loc", this.location);
      params.append("dep", this.department);
      const obj = axios({
        method: "post",
        url: this.$apiRoomPage1 + "Page02.php/loaddetail",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.datadetail = res.data.data;
        this.percent = res.data.percent;
        this.per_color = res.data.per_color;
        this.donut = res.data.donut;
        // this.filter_vendor_emb_all = [...new Set(res.data.map(item => item.VENDOR_NAME))].sort()
        // this.processDataEmbAll = res.data
        // this.filterDataEmb()
      });

      return obj;
    },
    LoadDataPending() {
      const postjson = {
        authen: { keycode: this.$keycode },
        filter: {
          loc: this.location,
          mcgrp: this.department,
          currentpage: this.currentTable1
        },
      };

      const obj = axios({
        method: "post",
        url: `${this.$apiflask}/nygctroom/board2/pending`,
        data: postjson,
      }).then((res) => {
        console.log(res.data);
        this.datapending = res.data.zrow;
        this.maxPage1 = res.data.total_page;
        this.pending_totalrow = res.data.records;
        this.pending_start = res.data.first_index;
        this.pending_end = res.data.last_index;
      });

      return obj;
    },
  },
};
